import { useTranslation } from 'react-i18next';

import s from './ReporterCell.module.scss';

import type { FC } from 'react';

interface IReporterCellProps {
  reporterTitle: string | null;
  reporterName: string;
  reportedByGuid: string;
  currentUserGuid: string;
}

const ReporterCell: FC<IReporterCellProps> = ({
  reporterTitle,
  reporterName,
  reportedByGuid,
  currentUserGuid,
}) => {
  const { t } = useTranslation();
  const isMe = reportedByGuid === currentUserGuid;
  const displayName = reporterTitle
    ? `${reporterTitle} ${reporterName}`
    : reporterName;

  return (
    <span data-cy="reporter-cell">
      {displayName}
      {isMe && (
        <span className={s['me-suffix']}>
          {' '}
          {t('tasksDashboard.reporter.me')}
        </span>
      )}
    </span>
  );
};

export default ReporterCell;
